module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAAAFCAYAAAAaPoE/AAAAK0lEQVQ4jWNkYGD4zzDCAcv3H38H2g0DDpgG2gGDAYwGAsNoIDAwMDAwAAAcOgP3jx4RyAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/text-line-2.png
// module id = YRlq
// module chunks = 1